import React, { useMemo, useState } from 'react';
import { useScratchpadContext } from '../../ScratchpadContext';
import { useAppDispatch } from '../../../../redux/hooks';
import {
  IDeleteScratchpadModalData,
  ModalSliceType,
  openModal,
} from '../../../../redux/slices/modal';
import ActionsMenu from '../../../ActionsMenu/ActionsMenu';
import { EntityRole } from '../../../../utils/apollo/graphqlSchema';
import useUser from '../../../../utils/hooks/useUser';
import { SingleSelectOption } from '../../../Dropdown/SingleSelect';

const ScratchpadHeaderActions = () => {
  const { selectedScratchpad, currentScratchpad, loading, refreshScratchpad } =
    useScratchpadContext();
  const dispatch = useAppDispatch();
  const user = useUser();

  const isOwner = useMemo(() => {
    if (!currentScratchpad?.permission.roleAssignments) {
      return false;
    }

    const ownerAssignment = currentScratchpad.permission.roleAssignments.find(
      (assignment) => assignment.role === EntityRole.Owner,
    );

    return ownerAssignment?.users.some((u) => u.id === user.id) ?? false;
  }, [currentScratchpad, user]);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const onDelete = () => {
    if (!selectedScratchpad) {
      return;
    }
    dispatch(
      openModal({
        type: ModalSliceType.DeleteScratchpad,
        data: {
          scratchpadId: selectedScratchpad,
        } satisfies IDeleteScratchpadModalData,
      }),
    );
  };

  const onRefresh = async () => {
    if (!selectedScratchpad || isRefreshing || loading) {
      return;
    }
    setIsRefreshing(true);
    try {
      await refreshScratchpad();
    } finally {
      setIsRefreshing(false);
    }
  };

  if (!isOwner) {
    return null;
  }

  return (
    <ActionsMenu
      iconSize={16}
      placement="bottom-end"
      disabled={isRefreshing || loading}
    >
      <SingleSelectOption
        iconName="refresh"
        label={'Refresh'}
        onClick={onRefresh}
      />
      <SingleSelectOption
        iconName="trash"
        label={'Delete'}
        onClick={onDelete}
      />
    </ActionsMenu>
  );
};

export default ScratchpadHeaderActions;
